module.exports = __webpack_public_path__ + "static/media/face-exhaling-svgrepo-com.874ac4a8.svg";